import { styled } from '@olxeu-jobs/ui';

export const SrText = styled<'span', { $visible?: boolean }>('span', ({ $visible = false }) => ({
  ...(!$visible && {
    border: '0',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap',
  }),
}));
